export const GOMS_FULFILLMENT_SUB_STATUS = {
  FAILED: 'FAILED',
  CREATED: 'CREATED',
  PENDING: 'PENDING',
  COMPLETED: 'COMPLETED',
  ON_HOLD: 'ON_HOLD',
  INITIATED: 'INITIATED',
  COMPLIANCE_PROCESSING: 'COMPLIANCE_PROCESSING'
};

export const TRM_STATUSES = {
  ON_HOLD: 'ON_HOLD',
  CHECK_FAILED: 'CHECK_FAILED',
  REJECTED: 'REJECTED',
  INELIGIBLE: 'INELIGIBLE',
  VERIFIED: 'VERIFIED',
  NEW: 'NEW'
};

/**
 * Default filters for goms on hold fulfillments screen
 * @type {{subStatuses: *[]}}
 */
export const GOMS_ON_HOLD_FULFILLMENT_DEFAULT_FILTERS = {
  subStatuses: [
    GOMS_FULFILLMENT_SUB_STATUS.ON_HOLD
  ]
};


// Constants for styling on hold fulfillment screen
export const SCREEN_STYLING_CONSTANTS = {
  GRID_RATIOS: {
    COLLAPSED: '10fr 0fr 0fr',
    EXPANDED: '7fr 0fr 3fr'
  },
  SIDEBAR_ANIMATION_DURATION: '0.3s'
}

export const PENDING_FOR_HOURS_OPTIONS = [1, 4, 8, 16, 32, 64, 96, 120, 144];